// extracted by mini-css-extract-plugin
export default {"root":"panel_root__ALPTA","placeHolderShimmer":"panel_placeHolderShimmer__DUV2e"};